import * as React from 'react';
import styled from 'styled-components';
import { DefaultTextBlack } from '../../../styles/global/css/GlobalText';
import { PrimaryColor, GreySidely, GreySidely4 } from '../../../styles/global/css/Utils';

// The titled field rows of the company popup, in their own module: Detail.tsx
// imports from products/product.tsx, so anything under products must take
// these from here — importing Detail from there closes an import cycle and
// styled-components then sees undefined components.

const CompanyDetailDisplayerTitle = styled.h4`
	color: ${GreySidely4};
	margin: 0;
	font-weight: 500;
	font-size: 12px;
`;

export const CompanyDetailDisplayerWrapper = styled.div`
	display: flex;
	gap: 15px;
	margin-top: 15px;
	flex-flow: column;
	width: 100%;
	padding-left: 16px;
`;

export const CompanyDetailDisplayerRowWrapper = styled.div`
	display: flex;
	flex-flow: column;
	gap: 4px;
	${DefaultTextBlack}
`;

export function CompanyDetailDisplayer(props: { title: React.ReactNode, children }) {
	return <CompanyDetailDisplayerRowWrapper>
		<CompanyDetailDisplayerTitle>
			{props.title}
		</CompanyDetailDisplayerTitle>
		{props.children}
	</CompanyDetailDisplayerRowWrapper>;

}

export const LineHoverDiv = styled.div<{ hover?: boolean }>`
	position: relative;
	margin-left: 7px;
	::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: 0;
		top: 4px;
		border-left: ${props => '1.5px solid ' + (props.hover ? PrimaryColor : GreySidely)}
	}
	:hover {
		::before {
			border-left: 1.5px solid ${PrimaryColor};
		}
	}
`;
